<template>
<div id="app">
  <Header />
  <div class="container" id="main-container">
    <div v-if="!challengeManagerOpened">
      <img alt="KegTap logo" src="./assets/logo.png" class="img-fluid" id="kegtap-logo" /><br />
      <h1 class="mt-4 mb-3" id="title">KegTap</h1>
      <p>A python powered self service portal</p>
      <b-button variant="primary" @click="openChallengeManager" class="mt-3">Reset Password</b-button>
    </div>
    <div v-if="challengeManagerOpened">
      <ChallengeManager ref="challengeManager" />
      <div v-if="showHome">
        <hr class="mt-5" />
        <b-button @click="back">Back</b-button>
      </div>
    </div>
  </div>
  <Footer />
</div>
</template>

<script>
import ChallengeManager from './ChallengeManager.vue';
import { mapState } from 'vuex';
import Header from 'Header';
import Footer from 'Footer';

export default {
  name: 'App',
  components: {
    ChallengeManager,
    Header,
    Footer
  },
  computed: mapState({
    challengeManagerOpened: state => state.challengeManagerOpened,
    showHome: state => process.env.VUE_APP_SHOW_HOME === 'true'
  }),
  mounted() {
    window.addEventListener('hashchange', this.checkTokenOnFragment);
    let tokenFound = this.checkTokenOnFragment();
    if (!this.showHome && !tokenFound) {
      this.openChallengeManager();
    }
  },
  destroyed() {
    window.removeEventListener('hashchange', this.checkTokenOnFragment);
  },
  methods: {
    checkTokenOnFragment() {
      if (!location.hash) {
        return;
      }
      let matchArray = location.hash.match(/#.*=(.*)/);
      if (matchArray && matchArray.length > 0) {
        let token = matchArray[1];
        location.hash = "";
        this.$store.commit('setChallengeManagerOpened', true);
        this.$store.dispatch('verifyEmail', token);
        return true;
      }
    },
    openChallengeManager() {
      this.$store.dispatch('initChallenge');
    },
    back() {
      this.$store.commit('setChallengeManagerOpened', false);
    }
  }
}
</script>

<style>
#title {
  font-weight: bold;
}

#kegtap-logo {
  max-width: 306px;
}

#kegtap-logo-mini {
  height: 2rem;
  padding-right: 10px;
}

#main-container {
  text-align: center;
}

.form-footer {
  padding-top: 1rem;
  border-top: 1px solid #dee2e6;
}
</style>
